var mobileRE =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

var tabletRE =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}
(function () {
  function isMobile(opts) {
    if (!opts) opts = {};
    var ua = opts.ua;
    if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
      ua = ua.headers["user-agent"];
    }
    if (typeof ua !== "string") return false;

    var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua);

    if (
      !result &&
      opts.tablet &&
      opts.featureDetect &&
      navigator &&
      navigator.maxTouchPoints > 1 &&
      ua.indexOf("Macintosh") !== -1 &&
      ua.indexOf("Safari") !== -1
    ) {
      result = true;
    }
    return result;
  }
  const isMobileDevice = isMobile();
  if (isMobileDevice) {
    $(".header__row.header__row-desktop .parent").remove();
    $(".header__row.header__row-mobile.three-segment .parent").css({
      gridColumn: "1/-1",
      margin: 0,
    });
  }
  $("#self-defined-search").css("visibility", "visible");
  $("#Search")
    .on(
      "input",
      debounce(function () {
        $("#quick-search-content-show").css({
          visibility: $(this).val() ? "visible" : "hidden",
        });
        if ($(".header__inner").find("#mobile-search-content").length) {
          const topHeight = $(".header__inner").outerHeight();
          $("#mobile-search-content").css({
            height: `calc(100vh - ${topHeight}px)`,
          });
        }

        quickSearch($(this).val());
      }, 200)
    )
    .focus(function () {
      if (isMobileDevice) {
        // 移除pc 搜索框
        $('[aria-label="Close menu modal"]').click();
        $("#quick-search-content-show").remove();
        $(".header__menu-icon.header__icon-touch.header__icon-menu").click(
          function () {
            $("[id]")
              .filter(function () {
                return $(this).attr("id") === "mobile-search-content";
              })
              .remove();
            $("#mobile-mask").remove();
            $("#search-handle-box").css({
              display: "none",
            });
            $(".reset-container").css("visibility", "hidden");
          }
        );
        // mobile 显示关闭清除
        $("#search-handle-box").css({
          display: "flex",
          alignItems: "center",
          height: "48px",
          overflow: "hidden",
          marginTop: "1px",
        });
        $("#reset-icon-x").click(function (e) {
          e.preventDefault();
          $("input[name='q']").val("");
        });
        $(".reset-container").css("visibility", "visible");
        // mobile 搜索内容区域
        const topHeight = $(".header__inner").outerHeight();
        const mobileSearchContent = $("<div></div>")
          .css({
            position: "absolute",
            backgroundColor: "#fff",
            left: 0,
            right: 0,
            height: $("input[name='q']").val()
              ? `calc(100vh - ${topHeight}px)`
              : "auto",
            width: "100%",

            overflow: "scroll",
            zIndex: 2,
          })
          .attr("id", "mobile-search-content");
        const quickSearchSuggested = document
          .getElementsByClassName("quick-search__suggested-wrapper")[0]
          .cloneNode(true);
        quickSearchSuggested.style.display = "block";
        const mobileMask = $("<div></div>")
          .css({
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 2,
          })
          .attr("id", "mobile-mask");
        if (!$(".header__inner").find("#mobile-search-content").length) {
          $(".header__inner").append(mobileSearchContent);
          if (!$("input[name='q']").val()) {
            $("#main").append(mobileMask);
            $("#mobile-search-content").append(quickSearchSuggested);
          }
        }
      } else {
        // 双遮罩方案：
        // 1) 页面遮罩（body 级 fixed div）盖住 header 下方所有页面内容
        // 2) 菜单遮罩（CSS pseudo on section）盖住 header 内菜单行 + 留白区域
        // 两层都用同色 rgba(0,0,0,0.35)，视觉无缝衔接。
        // Search 行不被任何遮罩覆盖（物理位置就在菜单上方）。
        let $overlay = $("#quick-search-overlay");
        if (!$overlay.length) {
          $overlay = $('<div id="quick-search-overlay"></div>')
            .css({
              position: "fixed",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: "calc(var(--z-index-header) - 1)",
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              opacity: 0,
              transition: "opacity 200ms ease",
              display: "none",
            })
            .appendTo("body");
        }
        $overlay.css("display", "block");
        requestAnimationFrame(function () {
          $overlay.css("opacity", "1");
        });

        // 计算菜单行相对 header section 的偏移，写到 CSS 变量供 pseudo 使用。
        // 监听 resize / scroll（含 sticky header 切换）以保持遮罩起点对齐。
        const sectionEl = document.querySelector(".shopify-section.header__outer-wrapper");
        const menuEl = document.querySelector(".header__links-primary-scroll-container");
        const updateMaskTop = function () {
          if (!sectionEl || !menuEl) return;
          const sectionRect = sectionEl.getBoundingClientRect();
          const menuRect = menuEl.getBoundingClientRect();
          sectionEl.style.setProperty(
            "--quick-search-mask-top",
            menuRect.top - sectionRect.top + "px"
          );
        };
        updateMaskTop();
        $(window)
          .off("resize.quickSearch scroll.quickSearch")
          .on("resize.quickSearch scroll.quickSearch", updateMaskTop);
        $("body").addClass("quick-search-active");

        const val = $(".search_form").find("input[name='q']").val();
        $("#quick-search-content-show").css({
          display: "flex",
          flexDirection: "column",
          visibility: val ? "visible" : "hidden",
        });

        const closeDesktopSearch = function () {
          $overlay.css("opacity", "0");
          setTimeout(function () {
            $overlay.css("display", "none");
          }, 200);
          $("body").removeClass("quick-search-active");
          $("#quick-search-content-show").css("display", "none");
          $("#quick-search-result-show").html("");
          $(document).off("keydown.quickSearch mousedown.quickSearch");
          $(window).off("resize.quickSearch scroll.quickSearch");
          $overlay.off("click.quickSearch");
        };

        $overlay.off("click.quickSearch").on("click.quickSearch", closeDesktopSearch);

        $(document)
          .off("keydown.quickSearch")
          .on("keydown.quickSearch", function (e) {
            if (e.key === "Escape" || e.keyCode === 27) {
              closeDesktopSearch();
              $("#Search").blur();
            }
          });

        $(document)
          .off("mousedown.quickSearch")
          .on("mousedown.quickSearch", function (e) {
            if (
              !$(e.target).closest("#self-defined-search, #quick-search-overlay").length
            ) {
              closeDesktopSearch();
            }
          });
      }
      // 聚焦重新搜索
      quickSearch($(this).val());
    });

  $("#search-close-icon").click(function () {
    $("[id]")
      .filter(function () {
        return $(this).attr("id") === "mobile-search-content";
      })
      .remove();
    $("#mobile-mask").remove();
    $("#search-handle-box").css({
      display: "none",
    });
    $(".reset-container").css("visibility", "hidden");
  });

  $(document).ready(function () {
    $("#search_form").submit(function () {
      quickSearch($("input[name='q']").val());
      return false;
    });
  });

  function quickSearch(val) {
    if (!val) return;

    $.ajax({
      url: `/search/suggest?q=${val}&section_id=predictive-search`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      success: function (response) {
        const transformRes = response.replaceAll(
          'class="quick-search__result quick-search__result--product quick-search__result--columns"',
          `class="quick-search__result quick-search__result--product quick-search__result--columns" style="display:inline-block;width:${
            isMobile() ? "50%" : "33%"
          }"`
        );
        $(
          isMobileDevice
            ? "#mobile-search-content"
            : "#quick-search-result-show"
        ).html(
          '<div class="quick-search__results" style="width:100%;padding-bottom: 65px;" data-results>' +
            transformRes +
            "</div>"
        );
        const doc = new DOMParser().parseFromString(response, "text/html");
        const element = doc.querySelector(
          ".quick-search__result.quick-search__result--product.quick-search__result--columns"
        );
        if (isMobileDevice) {
          const footerBox = $("<div>", {
            id: "quick-search-footer",
          }).css({ display: "none", position: "sticky", bottom: 0 });
          const searchButton = $("<button>", {
            type: "submit",
            class: "btn btn--primary btn--full",
            id: "search-button",
            text: "View all results",
          });
          footerBox.append(searchButton);
          $("#mobile-search-content").append(footerBox);
        }
        if (element) {
          $("#quick-search-footer")
            .css("display", "block")
            .click(function () {
              const val = $(".search_form").find("input[name='q']").val();
              $(".search_form").find("input[name='q']").val(val);
              $(".search_form").off("submit").submit();
            });
        } else {
          $("#quick-search-footer").css("display", "none");
        }
        $(
          ".quick-search__result.quick-search__result--product.quick-search__result--columns"
        ).wrapAll("<div class='product-container'></div>");
      },
    });
  }
})();
